import React from "react"
import {Stack, Typography} from "@mui/material"
import Questionaire from "./Questionaire"

export const widgetFragenkatalogPrototype = [
    {
        key: "lane",
        type: "SELECTTREE",
        label: "Fragebogen",
        size: 6,
        options: "questionList",
    },
    {
        key: "variant",
        type: "SELECT",
        label: "Variante",
        size: 6,
        options: [
            {value: "DEFAULT", label: "Default"},
            {value: "BORDERLESS", label: "Borderless"},
        ],
    },
]

const WidgetFragenkatalog = ({
    widget,
    value = [],
    getDataFromPointer,
    updateData,
    triggerAction,
    contextArea,
}) => {
    const lane = value ?? widget?.lane?.origin
    const variant = widget?.variant ?? "DEFAULT"
    return (
        <Stack spacing={2}>
            {variant === "DEFAULT" && lane?.longname && <Typography
                variant="h2"
                component="h2">
                {lane?.longname}
            </Typography>}
            {lane?.children?.map((questionaire) => (
                <Questionaire
                    key={questionaire.id}
                    questionaire={questionaire}
                    getDataFromPointer={getDataFromPointer}
                    updateData={updateData}
                    triggerAction={triggerAction}
                    contextArea={contextArea}
                    variant={variant}
                />
            ))}
        </Stack>
    )
}

export default WidgetFragenkatalog
